import state from "../store/index";

const AssetLeakTypes = [
  {
    key: 0,
    name: "VisibleHighVolume",
    displayName: state.getters["page/strings"].leakTypeVisibleHigh
  },
  {
    key: 1,
    name: "VisibleLowVolume",
    displayName: state.getters["page/strings"].leakTypeVisibleLow
  },
  {
    key: 2,
    name: "NonVisibleLowVolume",
    displayName: state.getters["page/strings"].leakTypeNonVisibleLow
  },
  {
    key: 3,
    name: "NonVisibleHighVolume",
    displayName: state.getters["page/strings"].leakTypeNonVisibleHigh
  }
];

export { AssetLeakTypes };
